/***
 * @file: è¯·æ±æ¥å£çapi
 * @author: linkun.he
 * @Date: 2019-06-03 10:11:13
 */
export const API = {
  // éåºç»å½
  logout: `/cli/logout`,
  // è·åç§æ·åè¡¨
  getAccountListUrl: `/cli/bus/client/get_tenants.do`,
  // è®¾ç½®é»è®¤ç§æ·
  settingDefaultAccountUrl: `/cli/bus/client/set_default_tenant.do`,
  // åæ¢è´¦æ·
  exchangeAccountUrl: `/cli/bus/client/change_tenant.do`,
  // ä¸è½½å¾ç ï¼ä¸éè¦tokenï¼
  downloadImageByPubUrl: `/pub/bus/file/image?fileId=`,
  querTask: '/cer/change/query_task',
};
